import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [ "corporationName", 'corporationNameError']
    connect() {
        console.log('connect!')
    }
    corporation_name_validation(){
        const element = this.corporationNameTarget;
        const errorElement = this.corporationNameErrorTarget;
        const username = element.value;
        //TODO エラー内容、メッセージはAPIでRailsから取得するようにする
        if(username.length <= 6){
            errorElement.innerHTML = '名称は6文字以上にしてください。';
            errorElement.style = 'display: block'
        }else{
            errorElement.style = 'display: none'
        }
    }
}